import React from "react";
import { Avatar, Box, Paper, Typography, IconButton, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/types";
import LinkIcon from "@mui/icons-material/Link";
import { i18n } from "../../../translate/i18n";

type Props = {
  goToEquipmentPage: CallableFunction,
  goToPlacePage: CallableFunction,
}

const EquipmentCard: React.FC<Props> = ({ goToEquipmentPage, goToPlacePage }) => {

  const selectedService = useSelector((state: RootState) => state.editService.selectedService);

  return(
    <Paper sx={sxs.equipmentCard}>
      <Box sx={sxs.mainSection}>
        <Box>
          {selectedService.equipment.photo ?
            <Avatar
              src={selectedService.equipment.photo.url}
              sx={sxs.avatar}
            />
            :
            <Avatar
              sx={sxs.avatarSmallText}
            >
              PHOTO
            </Avatar>
          }
        </Box>
        <Box sx={{display: 'flex', flexDirection: 'column'}}>
          <Box sx={{display: 'flex'}}>
            <Typography variant='h6'>
              {selectedService.equipment.equipmentModel.name}
            </Typography>
            <IconButton
              sx={{ marginLeft: '5px', cursor: 'pointer', padding: '0px 3px 0px 3px', borderRadius: 3 }}
              onClick={() => goToEquipmentPage()}
              size="large">
              <Tooltip title={i18n.t('editService.goToEquipment') as string}>
                <LinkIcon color='primary' />
              </Tooltip>
            </IconButton>
          </Box>
          <Typography sx={sxs.equipmentSerialNumber} variant='caption'>
            {`S/N: ${selectedService.equipment.serialNumber || ''}`}
          </Typography>
          <Box sx={{display: 'flex'}}>
            <Typography variant='subtitle1'>
              {selectedService.place.path}
            </Typography>
            <IconButton
              sx={{ marginLeft: '5px', cursor: 'pointer', padding: '0px 3px 0px 3px', borderRadius: 3 }}
              onClick={() => goToPlacePage()}
              size="large">
              <Tooltip title={i18n.t('editService.goToPlace') as string}>
                <LinkIcon color='primary' />
              </Tooltip>
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Paper>
  )
}

const sxs = {
  equipmentCard: {
    display: 'flex',
    padding: '40px 24px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '36px',
    borderRadius: '12px',
    border: '1px solid var(--primary-hover, #ECEEF3)',
    boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.20), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
    marginBottom: '48px',
  },
  mainSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: '40px'
  },
  avatar: {
    width: '80px',
    height: '80px',
  },
  avatarSmallText: {
    fontSize: '0.75rem',
    width: '80px',
    height: '80px',
    marginLeft: '0.25rem',
  },
  equipmentSerialNumber: {
    color: '#6F8189',
  },
}

export default EquipmentCard;